import { ref } from 'vue';
import { defineStore } from 'pinia';

interface State {
  featuresToured: string[];
}

const useFeatureTourStore = defineStore({
  id: 'feature-tour-status',
  state: () => ref <State>({
    featuresToured: []
  }),
  actions: {
    featureSeen(feature: string) : boolean {
      if (this.featuresToured.includes(feature)) {
        return true;
      }

      this.featuresToured.push(feature);
      return false;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage,
      },
    ],
  },
});

export default useFeatureTourStore;
